import React from 'react'
import { ScreenContentQAQCHistoryBase } from 'modules/reports/screens/screen-qaqc/content/ScreenContentQAQCHistoryBase'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'

/**
 */
export function ScreenContentQAQCAnomalyEvaluationHistory(): JSX.Element {
    return (
        <ScreenContentQAQCHistoryBase
            title={'Histórico de Avaliação de Anomalias'}
            type={QAQCExecutionTypeEnum.ANOMALY_EVALUATION}
            infoTitle={'Validações realizadas'}
            infoContent={
                <ol>
                    <li>
                        <strong>Dissolv./Total:</strong> Serão avaliados se os resultados da fração dissolvida de um
                        determinado parâmetro são inferiores às respectivas frações totais;
                    </li>
                    <li>
                        <strong>LQ:</strong> Serão avaliados se eventuais resultados menores que o limite de
                        quantificação (&lt;LQ) são inferiores aos limites normativos;
                    </li>
                    <li>
                        <strong>DQO/DBO:</strong> Serão avaliados se os resultados de DBO são inferiores aos
                        respectivos valores de DQO;
                    </li>
                    <li>
                        <strong>Oxigênio Dissolv.:</strong> Serão avaliados se os resultados de oxigênio dissolvido são
                        inferiores à 15 mg/L ou, quando possível, se são inferiores à concentração de saturação (Cs),
                        seguindo a equação de Pöpel;
                    </li>
                    <li>
                        <strong>STD/CE:</strong> Para as amostras cujo os valores de sólidos totais dissolvidos (STD)
                        forem inferiores à 3500,00 mg/L, serão avaliado se a razão STD e Condutividade elétrica (CE)
                        está dentro do intervalo de 0,55 e 0,75, conforme indicado na <a href="https://www.resolutionmineeis.us/documents/hem-1985">bibliografia de HEM (1985)</a>.
                    </li>
                </ol>
            }
        />
    )
}
